export const data = [
  { sigla: 'AC', state: 'Acre', ECH: 8, HE: 27, SE: 14, GE: 30, FE: 21 },
  { sigla: 'PI', state: 'Piauí', ECH: 6, HE: 28, SE: 13, GE: 31, FE: 22 },
  { sigla: 'AP', state: 'Amapá', ECH: 7, HE: 29, SE: 15, GE: 28, FE: 21 },
  { sigla: 'AM', state: 'Amazonas', ECH: 10, HE: 28, SE: 14, GE: 29, FE: 19 },
  { sigla: 'RO', state: 'Rondônia', ECH: 9, HE: 28, SE: 13, GE: 29, FE: 21 },
  { sigla: 'PA', state: 'Pará', ECH: 6, HE: 25, SE: 16, GE: 32, FE: 21 },
  { sigla: 'MA', state: 'Maranhão', ECH: 7, HE: 26, SE: 15, GE: 29, FE: 23 },
  { sigla: 'AL', state: 'Alagoas', ECH: 6, HE: 27, SE: 14, GE: 30, FE: 23 },
  { sigla: 'RR', state: 'Roraima', ECH: 11, HE: 23, SE: 14, GE: 32, FE: 20 },
  { sigla: 'TO', state: 'Tocantins', ECH: 8, HE: 25, SE: 16, GE: 31, FE: 20 },
  { sigla: 'RN', state: 'Rio Grande do Norte', ECH: 6, HE: 26, SE: 15, GE: 31, FE: 22 },
  { sigla: 'CE', state: 'Ceará', ECH: 5, HE: 25, SE: 14, GE: 31, FE: 25 },
  { sigla: 'PB', state: 'Paraíba', ECH: 5, HE: 27, SE: 16, GE: 31, FE: 21 },
  { sigla: 'PE', state: 'Pernambuco', ECH: 6, HE: 27, SE: 13, GE: 34, FE: 20 },
  { sigla: 'SE', state: 'Sergipe', ECH: 5, HE: 25, SE: 15, GE: 33, FE: 22 },
  { sigla: 'BA', state: 'Bahia', ECH: 7, HE: 27, SE: 12, GE: 32, FE: 22 },
  { sigla: 'MS', state: 'Mato Grosso do Sul', ECH: 9, HE: 25, SE: 14, GE: 31, FE: 21 },
  { sigla: 'GO', state: 'Goiás', ECH: 8, HE: 24, SE: 16, GE: 30, FE: 22 },
  { sigla: 'MT', state: 'Mato Grosso', ECH: 6, HE: 27, SE: 15, GE: 31, FE: 21 },
  { sigla: 'ES', state: 'Espírito Santo', ECH: 6, HE: 27, SE: 14, GE: 30, FE: 23 },
  { sigla: 'MG', state: 'Minas Gerais', ECH: 5, HE: 23, SE: 15, GE: 32, FE: 25 },
  { sigla: 'RJ', state: 'Rio de Janeiro', ECH: 5, HE: 26, SE: 14, GE: 33, FE: 22 },
  { sigla: 'RS', state: 'Rio Grande do Sul', ECH: 7, HE: 25, SE: 13, GE: 34, FE: 21 },
  { sigla: 'DF', state: 'Distrito Federal', ECH: 5, HE: 26, SE: 15, GE: 29, FE: 25 },
  { sigla: 'PR', state: 'Paraná', ECH: 7, HE: 23, SE: 17, GE: 28, FE: 25 },
  { sigla: 'SC', state: 'Santa Catarina', ECH: 7, HE: 26, SE: 14, GE: 28, FE: 25 },
  { sigla: 'SP', state: 'São Paulo', ECH: 6, HE: 25, SE: 13, GE: 32, FE: 24 }
];
